import { render } from "./BuildingsTable.vue?vue&type=template&id=1ff3140e"
import script from "./BuildingsTable.vue?vue&type=script&lang=js"
export * from "./BuildingsTable.vue?vue&type=script&lang=js"

import "./BuildingsTable.vue?vue&type=style&index=0&id=1ff3140e&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__